import React from 'react'
import PropTypes from 'prop-types'
import DeductionLine from './DeductionLine.js'

const Deductions = props => {
  const onChange = (index, change) => {
    let newDeductions = [...props.deductions]
    newDeductions[index] = { ...newDeductions[index], ...change }
    props.onChange(newDeductions)
  }

  const onDelete = index => {
    let newDeductions = [...props.deductions]
    newDeductions.splice(index, 1)
    props.onChange(newDeductions)
  }

  const onAdd = () => {
    let newDeductions = [...props.deductions]
    newDeductions.push({
      timeNum: 1,
      timeType: 'm',
      deductNum: 1,
      deductType: 'point',
    })
    props.onChange(newDeductions)
  }

  return (
    <div>
      {props.deductions.map((deduction, index) => (
        <DeductionLine
          disableDelete={props.deductions.length === 1}
          key={index}
          timeType={deduction.timeType}
          deductType={deduction.deductType}
          timeNum={deduction.timeNum}
          deductNum={deduction.deductNum}
          onChange={change => onChange(index, change)}
          onDelete={() => onDelete(index)}
        />
      ))}
      <button className="btn btn-sm mt-2" onClick={onAdd}>
        <span className="far fa-plus-circle fs-md" />
      </button>
    </div>
  )
}

Deductions.propTypes = {
  deductions: PropTypes.array,
  onChange: PropTypes.func,
}

export default Deductions
